import { useState, useRef, useEffect } from "react";
import RichContent from "./RichContent";

export default function ReflectionCardRichText({ htmlContent, maxLines = 6, setReadMore }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null);

    const checkOverflow = () => {
        if (contentRef.current) {
            // Use a small timeout to ensure the shadow DOM layout has been calculated
            setTimeout(() => {
                if (contentRef.current) {
                    const shadowRoot = contentRef.current.shadowRoot;
                    const internalBody = shadowRoot?.querySelector(".rich-content-body");
                    if (internalBody) {
                        const { scrollHeight } = internalBody;
                        const { clientHeight } = contentRef.current;
                        const isOverflowing = scrollHeight > clientHeight;
                        setReadMore(isOverflowing);
                    } else {
                        const { scrollHeight, clientHeight } = contentRef.current;
                        const isOverflowing = scrollHeight > clientHeight;
                        setReadMore(isOverflowing);
                    }
                }
            }, 100);
        }
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        const timer = setTimeout(checkOverflow, 1000);
        
        return () => {
            window.removeEventListener("resize", checkOverflow);
            clearTimeout(timer);
        };
    }, [htmlContent, maxLines]);

    return (
        <div>
            <RichContent
                ref={contentRef}
                content={htmlContent}
                maxLines={!isExpanded ? maxLines : 0}
                style={isExpanded ? { overflow: "visible" } : {}}
            />
        </div>
    );
}
